fragment DocumentSubject on Document {
  id
  subject
}
